module.exports = __webpack_public_path__ + "static/media/menu.8b320c1b.svg";